import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import ReportCard from "../../../../../components/reports/report-card.jsx";

const CardsContent = ({ data, boName }) => {
    const cards = data?.apprehension_cards;

    useEffect(() => {
        const values = [
            ["Total de apreensões", cards.apprehension_qty ?? 0],
            [`${boName} com apreensão`, cards.with_apprehension ?? 0],
            [`${boName} sem apreensão`, cards.without_apprehension ?? 0],
        ];

        ReportUtils.createExportableTable(["Descrição", "Quantidade"], values, "Cards");
    }, [data]);

    return (
        <>
            <div className="flex flex-col">
                <div className="grid grid-cols-3 gap-2">
                    <ReportCard title="Total de apreensões" value={cards.apprehension_qty ?? 0}/>
                    <ReportCard title={`${boName} com apreensão`} value={cards.with_apprehension ?? 0}/>
                    <ReportCard title={`${boName} sem apreensão`} value={cards.without_apprehension ?? 0}/>
                </div>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default CardsContent;